var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlog = function SvgBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M4.5 1.5h6.7a2.3 2.3 0 0 1 2.3 2.3V12a2.5 2.5 0 0 1-2.5 2.5H4.5A2.5 2.5 0 0 1 2 12V4a2.5 2.5 0 0 1 2.5-2.5ZM4.5 12H11M4.5 10H11M4.5 8H11M4.5 6H11M4.5 4H11"
  })));
};
export default SvgBlog;